// Kullanici (normal rol) icin dashboard iskeleti.
// Tum ortak mantik BaseLayout'ta. Bu dosya sadece user-taraf nav
// elemanlarini ve sirket adini saglar.
import React, { useMemo } from "react";
import BaseLayout from "./BaseLayout";
import { useI18n } from "../providers/I18nProvider";
import { useAuth } from "../contexts/AuthContext";
import { EXTERNAL_TOOLS } from "../config";

const hasToolPermission = (toolPermissions, key) =>
  Boolean(toolPermissions.find((p) => p.tool_key === key && p.granted));

const DashboardLayout = ({ children }) => {
  const { t } = useI18n();
  const { toolPermissions } = useAuth();

  const navSections = useMemo(() => {
    return [
      {
        title: t("nav.general"),
        items: [{ label: t("nav.home"), path: "/dashboard", match: "exact" }],
      },
      {
        title: t("nav.leave"),
        items: [
          { label: t("nav.leaves"), path: "/leaves", match: "exact" },
          { label: t("nav.leaveTypes"), path: "/leave-types", match: "exact" },
        ],
      },
      {
        title: t("nav.fleet"),
        items: [
          // Araç rezervasyonu tüm kullanıcılara açıktır (backend de yalnız
          // auth ister); tool-permission kapısı kaldırıldı.
          {
            label: t("nav.vehicleCalendar"),
            path: "/vehicles",
            match: "prefix",
          },
          {
            label: t("nav.myReservations"),
            path: "/reservations/my",
            match: "exact",
          },
        ],
      },
      {
        title: t("nav.sat"),
        items: [
          { label: t("nav.mySat"), path: "/sat-requests", match: "prefix" },
        ],
      },
      {
        title: t("nav.cctv"),
        items: [
          {
            label: t("nav.cctvLive"),
            path: "/cctv",
            match: "prefix",
            hidden: !hasToolPermission(toolPermissions, "cctv"),
          },
        ],
      },
      {
        title: "Şirket Araçları",
        items: [
          {
            label: "Tools",
            path: EXTERNAL_TOOLS.tools,
            match: "exact",
            hidden: !hasToolPermission(toolPermissions, "tools"),
            external: true,
          },
          {
            label: "BTO Website",
            path: EXTERNAL_TOOLS.cms,
            match: "exact",
            hidden: !hasToolPermission(toolPermissions, "cms"),
            external: true,
          },
          {
            label: "GitLab Editor",
            path: EXTERNAL_TOOLS.gitlabEditor,
            match: "exact",
            hidden: !hasToolPermission(toolPermissions, "gitlab_editor"),
            external: true,
          },
        ],
      },
    ];
  }, [t, toolPermissions]);

  return (
    <BaseLayout navSections={navSections} companyName="BOZANKAYA A.Ş">
      {children}
    </BaseLayout>
  );
};

export default DashboardLayout;
